<template>
  <div>
    <!-- <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-red"> -->
    <base-header class="pt-5 pb-8 bg-gradient-red">
      
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col class="col-md-12 col-xl-12">
          <b-card
            title="Book a one-on-one session with an expert to help you on your Bitcoin journey"
            sub-title="We can help you!"
            img-src="img/support.jpg"
            img-alt="Image"
            img-top
            tag="article"
            style="max-width: 100%;"
            class="mb-2 mr-2"
          >
            <b-card-text class="text-sm">
            Understanding Bitcoin can be overwhelming, especially if you are a newcomer to the space.<br>
            If you would like to be guided by an expert, we can pair you with the right person for as much time as you need.<br>
            <br>
            We can help you in the following topics:
              <ul>
                <li><strong>General</strong> concepts of Bitcoin</li>
                <li>How to <strong>buy</strong> your Bitcoin?</li>
                <li><strong>Custody</strong> and wallets: how to keep your Bitcoin safe?</li>
                <li><strong>Privacy</strong>: what are the alternatives to use Bitcoin in a private manner?</li>
                <li>Installing <strong>your own node</strong></li>
                <li>How to <strong>earn interest</strong> with your Bitcoin without selling it</li>
              </ul>
            If you are interested in such, do not hesitate to contact us to arrange a one-on-one session.<br/>
            Just drop an email at <span class="text-primary"> bitcoinminds@protonmail.com</span>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>

  export default {
    components: {
    },
    data() {
      return {
      };
    }
  };
</script>
<style>
</style>
